module.exports = __webpack_public_path__ + "static/media/Hand-Gel-Belgium-Getty_desktop.016122f9.jpg";